import React from 'react';
import { Translate } from 'react-redux-i18n';
import Datetime from 'components/Datetime';
import Cell from 'components/ListView/Cell';
import { NavLink } from 'react-router-dom';
import buildActualPath from 'helpers/build-actual-path';
import AuthFeature from 'components/AuthFeature';
import {
    NONUSER_CHARGE_DETAIL
} from 'constants/routes';
import { AUTH_VIEW_LINK_PAY_DETAIL } from 'constants/permission';
import {
    NONUSER_CHARGE_STATUS_SUCCESS,
    NONUSER_CHARGE_STATUS_UNPAID,
    NONUSER_CHARGE_STATUS_FAILED,
    NONUSER_CHARGE_STATUS_REVOKED,
    NONUSER_CHARGE_EXPENSE_TYPE_LOSS,
    NONUSER_CHARGE_EXPENSE_TYPE_REPAIR,
} from 'constants/nonuser-charge';
import { thousandsSeparator } from "helpers/util";

const ExpenseType = ({ type }) => {
    let el = null;
    switch (type) {
        case NONUSER_CHARGE_EXPENSE_TYPE_LOSS:
        case NONUSER_CHARGE_EXPENSE_TYPE_REPAIR:
            el = <Translate value={ `nonuser_charge.nonuser_expense_type_map.${ type }` } />;
            break;
        default:
            el = <span>--</span>;
            break;
    }
    return (
        <>
            { el }
        </>
    );
};

const ChargeStatusType = ({ type }) => {
    let el = null;
    switch (type) {
    case NONUSER_CHARGE_STATUS_UNPAID:
    case NONUSER_CHARGE_STATUS_SUCCESS:
    case NONUSER_CHARGE_STATUS_FAILED:
    case NONUSER_CHARGE_STATUS_REVOKED:
        el = <Translate value={ `nonuser_charge.nonuser_charge_status_map.${ type }` } />;
        break;
    default:
        el = <span>--</span>;
    };

    return (
        <>
            { el }
        </>
    );
};

const ListRow = ({ columns, data }) => {
    const renderField = ({ data, name, width}) => {
        let el = null;
        switch (name) {
        case 'title':
            el = (
                <AuthFeature
                    requiredList={ [AUTH_VIEW_LINK_PAY_DETAIL] }
                    fallback={ () => data.title }
                >
                    <NavLink to={ buildActualPath(NONUSER_CHARGE_DETAIL, { linkPayId: data.link_pay_id }) }>
                        { data.title }
                    </NavLink>
                </AuthFeature>
            );
            break;
        case 'expense_type':
            el = <ExpenseType type={ data[name] } />;
            break;
        case 'amount':
            el = thousandsSeparator(data.amount);
            break;
        case 'create_time':
            el = (<Datetime time={ data[name] } />);
            break;
        case 'status':
            el = (<ChargeStatusType type={ data.status } />);
            break;
        default:
            el = data[name] === '' || data[name] == null ? '--' : data[name];
            break;
        }
        return (
            <Cell
                key={ `${ data.order_id }-${ name }` }
                name={ name }
                style={ {
                    width,
                } }
            >
                { el }
            </Cell>
        );
    }

    return columns.map(({ key, width }) => {
        return renderField({ data, width, name: key });
    });
}

export default ListRow;
